/* jshint ignore:start */
import Component from 'metal-component';
import Soy from 'metal-soy';

var templates;
goog.loadModule(function(exports) {
var soy = goog.require('soy');
var soydata = goog.require('soydata');
// This file was automatically generated from ClayDropdownItem.soy.
// Please don't edit this file by hand.

/**
 * @fileoverview Templates in namespace ClayDropdownItem.
 * @hassoydeltemplate {ClayDropdownItem.Item.idom}
 * @hassoydelcall {ClayDropdownItem.Item.idom}
 * @public
 */

goog.module('ClayDropdownItem.incrementaldom');

goog.require('goog.soy.data.SanitizedContent');
var incrementalDom = goog.require('incrementaldom');
goog.require('soy');
goog.require('soy.asserts');
var soyIdom = goog.require('soy.idom');

var $templateAlias4 = Soy.getTemplate('ClayButton.incrementaldom', 'render');

var $templateAlias5 = Soy.getTemplate('ClayCheckbox.incrementaldom', 'render');

var $templateAlias6 = Soy.getTemplate('ClayDropdownBase.incrementaldom', 'items');

var $templateAlias2 = Soy.getTemplate('ClayDropdownLabel.incrementaldom', 'render');

var $templateAlias1 = Soy.getTemplate('ClayIcon.incrementaldom', 'render');

var $templateAlias3 = Soy.getTemplate('ClayLink.incrementaldom', 'render');

var $templateAlias7 = Soy.getTemplate('ClayRadio.incrementaldom', 'render');


/**
 * @param {{
 *  _handleItemClick: (*|null|undefined),
 *  _handleItemKeyDown: (*|null|undefined),
 *  active: (boolean|null|undefined),
 *  checked: (boolean|null|undefined),
 *  contentRenderer: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  disabled: (boolean|null|undefined),
 *  href: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  icon: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  icons: (?),
 *  inputName: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  inputValue: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  items: (!Array<?>|null|undefined),
 *  itemsIconAlignment: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  label: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  maxItems: (null|number|undefined),
 *  separator: (boolean|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  target: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  title: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  type: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes}
 */
function $render(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  var $$temp;
  opt_data = opt_data || {};
  /** @type {*|null|undefined} */
  var _handleItemClick = opt_data._handleItemClick;
  /** @type {*|null|undefined} */
  var _handleItemKeyDown = opt_data._handleItemKeyDown;
  /** @type {boolean|null|undefined} */
  var active = soy.asserts.assertType(opt_data.active == null || (goog.isBoolean(opt_data.active) || opt_data.active === 1 || opt_data.active === 0), 'active', opt_data.active, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var checked = soy.asserts.assertType(opt_data.checked == null || (goog.isBoolean(opt_data.checked) || opt_data.checked === 1 || opt_data.checked === 0), 'checked', opt_data.checked, 'boolean|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var contentRenderer = soy.asserts.assertType(opt_data.contentRenderer == null || (goog.isString(opt_data.contentRenderer) || opt_data.contentRenderer instanceof goog.soy.data.SanitizedContent), 'contentRenderer', opt_data.contentRenderer, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {boolean|null|undefined} */
  var disabled = soy.asserts.assertType(opt_data.disabled == null || (goog.isBoolean(opt_data.disabled) || opt_data.disabled === 1 || opt_data.disabled === 0), 'disabled', opt_data.disabled, 'boolean|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var href = soy.asserts.assertType(opt_data.href == null || (goog.isString(opt_data.href) || opt_data.href instanceof goog.soy.data.SanitizedContent), 'href', opt_data.href, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var icon = soy.asserts.assertType(opt_data.icon == null || (goog.isString(opt_data.icon) || opt_data.icon instanceof goog.soy.data.SanitizedContent), 'icon', opt_data.icon, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {?} */
  var icons = opt_data.icons;
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var inputName = soy.asserts.assertType(opt_data.inputName == null || (goog.isString(opt_data.inputName) || opt_data.inputName instanceof goog.soy.data.SanitizedContent), 'inputName', opt_data.inputName, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var inputValue = soy.asserts.assertType(opt_data.inputValue == null || (goog.isString(opt_data.inputValue) || opt_data.inputValue instanceof goog.soy.data.SanitizedContent), 'inputValue', opt_data.inputValue, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!Array<?>|null|undefined} */
  var items = soy.asserts.assertType(opt_data.items == null || goog.isArray(opt_data.items), 'items', opt_data.items, '!Array<?>|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var itemsIconAlignment = soy.asserts.assertType(opt_data.itemsIconAlignment == null || (goog.isString(opt_data.itemsIconAlignment) || opt_data.itemsIconAlignment instanceof goog.soy.data.SanitizedContent), 'itemsIconAlignment', opt_data.itemsIconAlignment, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var label = soy.asserts.assertType(opt_data.label == null || (goog.isString(opt_data.label) || opt_data.label instanceof goog.soy.data.SanitizedContent), 'label', opt_data.label, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {null|number|undefined} */
  var maxItems = soy.asserts.assertType(opt_data.maxItems == null || goog.isNumber(opt_data.maxItems), 'maxItems', opt_data.maxItems, 'null|number|undefined');
  /** @type {boolean|null|undefined} */
  var separator = soy.asserts.assertType(opt_data.separator == null || (goog.isBoolean(opt_data.separator) || opt_data.separator === 1 || opt_data.separator === 0), 'separator', opt_data.separator, 'boolean|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var spritemap = soy.asserts.assertType(opt_data.spritemap == null || (goog.isString(opt_data.spritemap) || opt_data.spritemap instanceof goog.soy.data.SanitizedContent), 'spritemap', opt_data.spritemap, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var target = soy.asserts.assertType(opt_data.target == null || (goog.isString(opt_data.target) || opt_data.target instanceof goog.soy.data.SanitizedContent), 'target', opt_data.target, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var title = soy.asserts.assertType(opt_data.title == null || (goog.isString(opt_data.title) || opt_data.title instanceof goog.soy.data.SanitizedContent), 'title', opt_data.title, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var type = soy.asserts.assertType(opt_data.type == null || (goog.isString(opt_data.type) || opt_data.type instanceof goog.soy.data.SanitizedContent), 'type', opt_data.type, '!goog.soy.data.SanitizedContent|null|string|undefined');
  var variant__soy845 = ($$temp = contentRenderer) == null ? 'item' : $$temp;
  soy.$$getDelegateFn(soy.$$getDelTemplateId('ClayDropdownItem.Item.idom'), variant__soy845, false)({_handleItemClick: _handleItemClick, _handleItemKeyDown: _handleItemKeyDown, active: active, checked: checked, disabled: disabled, href: href, icon: icon, icons: icons, inputName: inputName, inputValue: inputValue, items: items, itemsIconAlignment: itemsIconAlignment, label: label ? '' + label : '', maxItems: maxItems, separator: separator, spritemap: spritemap, target: target, title: title, type: type}, null, opt_ijData);
}
exports.render = $render;
/**
 * @typedef {{
 *  _handleItemClick: (*|null|undefined),
 *  _handleItemKeyDown: (*|null|undefined),
 *  active: (boolean|null|undefined),
 *  checked: (boolean|null|undefined),
 *  contentRenderer: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  disabled: (boolean|null|undefined),
 *  href: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  icon: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  icons: (?),
 *  inputName: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  inputValue: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  items: (!Array<?>|null|undefined),
 *  itemsIconAlignment: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  label: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  maxItems: (null|number|undefined),
 *  separator: (boolean|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  target: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  title: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  type: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }}
 */
$render.Params;
if (goog.DEBUG) {
  $render.soyTemplateName = 'ClayDropdownItem.render';
}


/**
 * @param {{
 *  label: (!goog.soy.data.SanitizedContent|string),
 *  _handleItemClick: (*|null|undefined),
 *  _handleItemKeyDown: (*|null|undefined),
 *  active: (boolean|null|undefined),
 *  checked: (boolean|null|undefined),
 *  disabled: (boolean|null|undefined),
 *  href: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  icon: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  icons: (?),
 *  inputName: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  inputValue: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  items: (!Array<?>|null|undefined),
 *  itemsIconAlignment: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  maxItems: (null|number|undefined),
 *  separator: (boolean|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  target: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  title: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  type: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes}
 */
function __deltemplate_s868_3e6ffd21(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  /** @type {!goog.soy.data.SanitizedContent|string} */
  var label = soy.asserts.assertType(goog.isString(opt_data.label) || opt_data.label instanceof goog.soy.data.SanitizedContent, 'label', opt_data.label, '!goog.soy.data.SanitizedContent|string');
  /** @type {*|null|undefined} */
  var _handleItemClick = opt_data._handleItemClick;
  /** @type {*|null|undefined} */
  var _handleItemKeyDown = opt_data._handleItemKeyDown;
  /** @type {boolean|null|undefined} */
  var active = soy.asserts.assertType(opt_data.active == null || (goog.isBoolean(opt_data.active) || opt_data.active === 1 || opt_data.active === 0), 'active', opt_data.active, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var checked = soy.asserts.assertType(opt_data.checked == null || (goog.isBoolean(opt_data.checked) || opt_data.checked === 1 || opt_data.checked === 0), 'checked', opt_data.checked, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var disabled = soy.asserts.assertType(opt_data.disabled == null || (goog.isBoolean(opt_data.disabled) || opt_data.disabled === 1 || opt_data.disabled === 0), 'disabled', opt_data.disabled, 'boolean|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var href = soy.asserts.assertType(opt_data.href == null || (goog.isString(opt_data.href) || opt_data.href instanceof goog.soy.data.SanitizedContent), 'href', opt_data.href, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var icon = soy.asserts.assertType(opt_data.icon == null || (goog.isString(opt_data.icon) || opt_data.icon instanceof goog.soy.data.SanitizedContent), 'icon', opt_data.icon, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {?} */
  var icons = opt_data.icons;
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var inputName = soy.asserts.assertType(opt_data.inputName == null || (goog.isString(opt_data.inputName) || opt_data.inputName instanceof goog.soy.data.SanitizedContent), 'inputName', opt_data.inputName, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var inputValue = soy.asserts.assertType(opt_data.inputValue == null || (goog.isString(opt_data.inputValue) || opt_data.inputValue instanceof goog.soy.data.SanitizedContent), 'inputValue', opt_data.inputValue, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!Array<?>|null|undefined} */
  var items = soy.asserts.assertType(opt_data.items == null || goog.isArray(opt_data.items), 'items', opt_data.items, '!Array<?>|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var itemsIconAlignment = soy.asserts.assertType(opt_data.itemsIconAlignment == null || (goog.isString(opt_data.itemsIconAlignment) || opt_data.itemsIconAlignment instanceof goog.soy.data.SanitizedContent), 'itemsIconAlignment', opt_data.itemsIconAlignment, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {null|number|undefined} */
  var maxItems = soy.asserts.assertType(opt_data.maxItems == null || goog.isNumber(opt_data.maxItems), 'maxItems', opt_data.maxItems, 'null|number|undefined');
  /** @type {boolean|null|undefined} */
  var separator = soy.asserts.assertType(opt_data.separator == null || (goog.isBoolean(opt_data.separator) || opt_data.separator === 1 || opt_data.separator === 0), 'separator', opt_data.separator, 'boolean|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var spritemap = soy.asserts.assertType(opt_data.spritemap == null || (goog.isString(opt_data.spritemap) || opt_data.spritemap instanceof goog.soy.data.SanitizedContent), 'spritemap', opt_data.spritemap, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var target = soy.asserts.assertType(opt_data.target == null || (goog.isString(opt_data.target) || opt_data.target instanceof goog.soy.data.SanitizedContent), 'target', opt_data.target, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var title = soy.asserts.assertType(opt_data.title == null || (goog.isString(opt_data.title) || opt_data.title instanceof goog.soy.data.SanitizedContent), 'title', opt_data.title, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var type = soy.asserts.assertType(opt_data.type == null || (goog.isString(opt_data.type) || opt_data.type instanceof goog.soy.data.SanitizedContent), 'type', opt_data.type, '!goog.soy.data.SanitizedContent|null|string|undefined');
  var itemContent__soy889 = function() {
    var elementClasses__soy891 = '';
    elementClasses__soy891 += 'dropdown-item';
    elementClasses__soy891 += active ? ' active' : '';
    elementClasses__soy891 += disabled ? ' disabled' : '';
    var labelContent__soy902 = function() {
      var iconContent__soy904 = function() {
        if (icon && spritemap) {
          var classes__soy909 = '';
          var $tmp = null;
if (itemsIconAlignment == 'left') {
  $tmp = 'dropdown-item-indicator-start';
} else if (itemsIconAlignment == 'right') {
  $tmp = 'dropdown-item-indicator-end';
} else {
  $tmp = '';
}
classes__soy909 += $tmp;
          incrementalDom.elementOpenStart('span');
              incrementalDom.attr('class', classes__soy909);
          incrementalDom.elementOpenEnd();
            $templateAlias1({spritemap: spritemap, symbol: icon}, null, opt_ijData);
          incrementalDom.elementClose('span');
        }
      };
      if (icons && icons.left && spritemap) {
        incrementalDom.elementOpenStart('span');
            incrementalDom.attr('class', 'dropdown-item-indicator-start');
        incrementalDom.elementOpenEnd();
          $templateAlias1({spritemap: spritemap, symbol: icons.left}, null, opt_ijData);
        incrementalDom.elementClose('span');
      } else {
        if (icon && itemsIconAlignment == 'left') {
          iconContent__soy904();
        }
      }
      $templateAlias2(opt_data, null, opt_ijData);
      if (icons && icons.right && spritemap) {
        incrementalDom.elementOpenStart('span');
            incrementalDom.attr('class', 'dropdown-item-indicator-end');
        incrementalDom.elementOpenEnd();
          $templateAlias1({spritemap: spritemap, symbol: icons.right}, null, opt_ijData);
        incrementalDom.elementClose('span');
      } else {
        if (icon && itemsIconAlignment == 'right') {
          iconContent__soy904();
        }
      }
    };
    if (href) {
      var $tmp$$1 = null;
      if (disabled) {
        $tmp$$1 = 'javascript:;';
      } else if (href) {
        $tmp$$1 = href;
      } else {
        $tmp$$1 = '';
      }
      $templateAlias3({elementClasses: elementClasses__soy891, href: '' + $tmp$$1, label: labelContent__soy902, target: target, title: title}, null, opt_ijData);
    } else {
      $templateAlias4({ariaLabel: label, disabled: disabled, elementClasses: elementClasses__soy891, label: labelContent__soy902, size: 'sm', spritemap: spritemap, style: 'link'}, null, opt_ijData);
    }
  };
  var itemAttributes__soy994 = function() {
    if (!disabled) {
      incrementalDom.attr('data-onclick', _handleItemClick);
    }
    incrementalDom.attr('data-onkeydown', _handleItemKeyDown);
    incrementalDom.attr('tabindex', '-1');
  };
  incrementalDom.elementOpenStart('li');
      itemAttributes__soy994();
  incrementalDom.elementOpenEnd();
    itemContent__soy889();
  incrementalDom.elementClose('li');
}
exports.__deltemplate_s868_3e6ffd21 = __deltemplate_s868_3e6ffd21;
/**
 * @typedef {{
 *  label: (!goog.soy.data.SanitizedContent|string),
 *  _handleItemClick: (*|null|undefined),
 *  _handleItemKeyDown: (*|null|undefined),
 *  active: (boolean|null|undefined),
 *  checked: (boolean|null|undefined),
 *  disabled: (boolean|null|undefined),
 *  href: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  icon: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  icons: (?),
 *  inputName: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  inputValue: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  items: (!Array<?>|null|undefined),
 *  itemsIconAlignment: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  maxItems: (null|number|undefined),
 *  separator: (boolean|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  target: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  title: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  type: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }}
 */
__deltemplate_s868_3e6ffd21.Params;
if (goog.DEBUG) {
  __deltemplate_s868_3e6ffd21.soyTemplateName = 'ClayDropdownItem.__deltemplate_s868_3e6ffd21';
}
soy.$$registerDelegateFn(soy.$$getDelTemplateId('ClayDropdownItem.Item.idom'), '', 0, __deltemplate_s868_3e6ffd21);


/**
 * @param {{
 *  label: (!goog.soy.data.SanitizedContent|string),
 *  _handleItemClick: (*|null|undefined),
 *  _handleItemKeyDown: (*|null|undefined),
 *  active: (boolean|null|undefined),
 *  checked: (boolean|null|undefined),
 *  disabled: (boolean|null|undefined),
 *  href: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  icon: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  icons: (?),
 *  inputName: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  inputValue: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  items: (!Array<?>|null|undefined),
 *  itemsIconAlignment: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  maxItems: (null|number|undefined),
 *  separator: (boolean|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  target: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  title: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  type: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes}
 */
function __deltemplate_s1009_27296c4e(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  /** @type {!goog.soy.data.SanitizedContent|string} */
  var label = soy.asserts.assertType(goog.isString(opt_data.label) || opt_data.label instanceof goog.soy.data.SanitizedContent, 'label', opt_data.label, '!goog.soy.data.SanitizedContent|string');
  /** @type {*|null|undefined} */
  var _handleItemClick = opt_data._handleItemClick;
  /** @type {*|null|undefined} */
  var _handleItemKeyDown = opt_data._handleItemKeyDown;
  /** @type {boolean|null|undefined} */
  var active = soy.asserts.assertType(opt_data.active == null || (goog.isBoolean(opt_data.active) || opt_data.active === 1 || opt_data.active === 0), 'active', opt_data.active, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var checked = soy.asserts.assertType(opt_data.checked == null || (goog.isBoolean(opt_data.checked) || opt_data.checked === 1 || opt_data.checked === 0), 'checked', opt_data.checked, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var disabled = soy.asserts.assertType(opt_data.disabled == null || (goog.isBoolean(opt_data.disabled) || opt_data.disabled === 1 || opt_data.disabled === 0), 'disabled', opt_data.disabled, 'boolean|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var href = soy.asserts.assertType(opt_data.href == null || (goog.isString(opt_data.href) || opt_data.href instanceof goog.soy.data.SanitizedContent), 'href', opt_data.href, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var icon = soy.asserts.assertType(opt_data.icon == null || (goog.isString(opt_data.icon) || opt_data.icon instanceof goog.soy.data.SanitizedContent), 'icon', opt_data.icon, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {?} */
  var icons = opt_data.icons;
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var inputName = soy.asserts.assertType(opt_data.inputName == null || (goog.isString(opt_data.inputName) || opt_data.inputName instanceof goog.soy.data.SanitizedContent), 'inputName', opt_data.inputName, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var inputValue = soy.asserts.assertType(opt_data.inputValue == null || (goog.isString(opt_data.inputValue) || opt_data.inputValue instanceof goog.soy.data.SanitizedContent), 'inputValue', opt_data.inputValue, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!Array<?>|null|undefined} */
  var items = soy.asserts.assertType(opt_data.items == null || goog.isArray(opt_data.items), 'items', opt_data.items, '!Array<?>|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var itemsIconAlignment = soy.asserts.assertType(opt_data.itemsIconAlignment == null || (goog.isString(opt_data.itemsIconAlignment) || opt_data.itemsIconAlignment instanceof goog.soy.data.SanitizedContent), 'itemsIconAlignment', opt_data.itemsIconAlignment, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {null|number|undefined} */
  var maxItems = soy.asserts.assertType(opt_data.maxItems == null || goog.isNumber(opt_data.maxItems), 'maxItems', opt_data.maxItems, 'null|number|undefined');
  /** @type {boolean|null|undefined} */
  var separator = soy.asserts.assertType(opt_data.separator == null || (goog.isBoolean(opt_data.separator) || opt_data.separator === 1 || opt_data.separator === 0), 'separator', opt_data.separator, 'boolean|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var spritemap = soy.asserts.assertType(opt_data.spritemap == null || (goog.isString(opt_data.spritemap) || opt_data.spritemap instanceof goog.soy.data.SanitizedContent), 'spritemap', opt_data.spritemap, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var target = soy.asserts.assertType(opt_data.target == null || (goog.isString(opt_data.target) || opt_data.target instanceof goog.soy.data.SanitizedContent), 'target', opt_data.target, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var title = soy.asserts.assertType(opt_data.title == null || (goog.isString(opt_data.title) || opt_data.title instanceof goog.soy.data.SanitizedContent), 'title', opt_data.title, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var type = soy.asserts.assertType(opt_data.type == null || (goog.isString(opt_data.type) || opt_data.type instanceof goog.soy.data.SanitizedContent), 'type', opt_data.type, '!goog.soy.data.SanitizedContent|null|string|undefined');
  var checkbox__soy1030 = function() {
    $templateAlias5({checked: checked, disabled: disabled, inline: true, label: label, name: inputName, value: inputValue}, null, opt_ijData);
  };
  var itemAttributes__soy1041 = function() {
    incrementalDom.attr('class', 'dropdown-item' + (active || checked ? ' active' : ''));
    if (!disabled) {
      incrementalDom.attr('data-onchange', _handleItemClick);
    }
    incrementalDom.attr('data-onkeydown', _handleItemKeyDown);
    incrementalDom.attr('tabindex', '-1');
  };
  incrementalDom.elementOpenStart('li');
      itemAttributes__soy1041();
  incrementalDom.elementOpenEnd();
    checkbox__soy1030();
  incrementalDom.elementClose('li');
}
exports.__deltemplate_s1009_27296c4e = __deltemplate_s1009_27296c4e;
/**
 * @typedef {{
 *  label: (!goog.soy.data.SanitizedContent|string),
 *  _handleItemClick: (*|null|undefined),
 *  _handleItemKeyDown: (*|null|undefined),
 *  active: (boolean|null|undefined),
 *  checked: (boolean|null|undefined),
 *  disabled: (boolean|null|undefined),
 *  href: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  icon: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  icons: (?),
 *  inputName: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  inputValue: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  items: (!Array<?>|null|undefined),
 *  itemsIconAlignment: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  maxItems: (null|number|undefined),
 *  separator: (boolean|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  target: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  title: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  type: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }}
 */
__deltemplate_s1009_27296c4e.Params;
if (goog.DEBUG) {
  __deltemplate_s1009_27296c4e.soyTemplateName = 'ClayDropdownItem.__deltemplate_s1009_27296c4e';
}
soy.$$registerDelegateFn(soy.$$getDelTemplateId('ClayDropdownItem.Item.idom'), 'checkbox', 0, __deltemplate_s1009_27296c4e);


/**
 * @param {{
 *  label: (!goog.soy.data.SanitizedContent|string),
 *  _handleItemClick: (*|null|undefined),
 *  _handleItemKeyDown: (*|null|undefined),
 *  active: (boolean|null|undefined),
 *  checked: (boolean|null|undefined),
 *  disabled: (boolean|null|undefined),
 *  href: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  icon: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  icons: (?),
 *  inputName: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  inputValue: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  items: (!Array<?>|null|undefined),
 *  itemsIconAlignment: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  maxItems: (null|number|undefined),
 *  separator: (boolean|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  target: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  title: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  type: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  contentRenderer: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes}
 */
function __deltemplate_s1060_4a8d8c89(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  /** @type {!goog.soy.data.SanitizedContent|string} */
  var label = soy.asserts.assertType(goog.isString(opt_data.label) || opt_data.label instanceof goog.soy.data.SanitizedContent, 'label', opt_data.label, '!goog.soy.data.SanitizedContent|string');
  /** @type {*|null|undefined} */
  var _handleItemClick = opt_data._handleItemClick;
  /** @type {*|null|undefined} */
  var _handleItemKeyDown = opt_data._handleItemKeyDown;
  /** @type {boolean|null|undefined} */
  var active = soy.asserts.assertType(opt_data.active == null || (goog.isBoolean(opt_data.active) || opt_data.active === 1 || opt_data.active === 0), 'active', opt_data.active, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var checked = soy.asserts.assertType(opt_data.checked == null || (goog.isBoolean(opt_data.checked) || opt_data.checked === 1 || opt_data.checked === 0), 'checked', opt_data.checked, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var disabled = soy.asserts.assertType(opt_data.disabled == null || (goog.isBoolean(opt_data.disabled) || opt_data.disabled === 1 || opt_data.disabled === 0), 'disabled', opt_data.disabled, 'boolean|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var href = soy.asserts.assertType(opt_data.href == null || (goog.isString(opt_data.href) || opt_data.href instanceof goog.soy.data.SanitizedContent), 'href', opt_data.href, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var icon = soy.asserts.assertType(opt_data.icon == null || (goog.isString(opt_data.icon) || opt_data.icon instanceof goog.soy.data.SanitizedContent), 'icon', opt_data.icon, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {?} */
  var icons = opt_data.icons;
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var inputName = soy.asserts.assertType(opt_data.inputName == null || (goog.isString(opt_data.inputName) || opt_data.inputName instanceof goog.soy.data.SanitizedContent), 'inputName', opt_data.inputName, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var inputValue = soy.asserts.assertType(opt_data.inputValue == null || (goog.isString(opt_data.inputValue) || opt_data.inputValue instanceof goog.soy.data.SanitizedContent), 'inputValue', opt_data.inputValue, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!Array<?>|null|undefined} */
  var items = soy.asserts.assertType(opt_data.items == null || goog.isArray(opt_data.items), 'items', opt_data.items, '!Array<?>|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var itemsIconAlignment = soy.asserts.assertType(opt_data.itemsIconAlignment == null || (goog.isString(opt_data.itemsIconAlignment) || opt_data.itemsIconAlignment instanceof goog.soy.data.SanitizedContent), 'itemsIconAlignment', opt_data.itemsIconAlignment, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {null|number|undefined} */
  var maxItems = soy.asserts.assertType(opt_data.maxItems == null || goog.isNumber(opt_data.maxItems), 'maxItems', opt_data.maxItems, 'null|number|undefined');
  /** @type {boolean|null|undefined} */
  var separator = soy.asserts.assertType(opt_data.separator == null || (goog.isBoolean(opt_data.separator) || opt_data.separator === 1 || opt_data.separator === 0), 'separator', opt_data.separator, 'boolean|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var spritemap = soy.asserts.assertType(opt_data.spritemap == null || (goog.isString(opt_data.spritemap) || opt_data.spritemap instanceof goog.soy.data.SanitizedContent), 'spritemap', opt_data.spritemap, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var target = soy.asserts.assertType(opt_data.target == null || (goog.isString(opt_data.target) || opt_data.target instanceof goog.soy.data.SanitizedContent), 'target', opt_data.target, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var title = soy.asserts.assertType(opt_data.title == null || (goog.isString(opt_data.title) || opt_data.title instanceof goog.soy.data.SanitizedContent), 'title', opt_data.title, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var type = soy.asserts.assertType(opt_data.type == null || (goog.isString(opt_data.type) || opt_data.type instanceof goog.soy.data.SanitizedContent), 'type', opt_data.type, '!goog.soy.data.SanitizedContent|null|string|undefined');
  if (label && label != '') {
    incrementalDom.elementOpenStart('li');
        incrementalDom.attr('class', 'dropdown-subheader');
        incrementalDom.attr('role', 'presentation');
    incrementalDom.elementOpenEnd();
      soyIdom.print(label);
    incrementalDom.elementClose('li');
  }
  if (items) {
    $templateAlias6(opt_data, null, opt_ijData);
  }
}
exports.__deltemplate_s1060_4a8d8c89 = __deltemplate_s1060_4a8d8c89;
/**
 * @typedef {{
 *  label: (!goog.soy.data.SanitizedContent|string),
 *  _handleItemClick: (*|null|undefined),
 *  _handleItemKeyDown: (*|null|undefined),
 *  active: (boolean|null|undefined),
 *  checked: (boolean|null|undefined),
 *  disabled: (boolean|null|undefined),
 *  href: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  icon: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  icons: (?),
 *  inputName: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  inputValue: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  items: (!Array<?>|null|undefined),
 *  itemsIconAlignment: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  maxItems: (null|number|undefined),
 *  separator: (boolean|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  target: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  title: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  type: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  contentRenderer: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }}
 */
__deltemplate_s1060_4a8d8c89.Params;
if (goog.DEBUG) {
  __deltemplate_s1060_4a8d8c89.soyTemplateName = 'ClayDropdownItem.__deltemplate_s1060_4a8d8c89';
}
soy.$$registerDelegateFn(soy.$$getDelTemplateId('ClayDropdownItem.Item.idom'), 'group', 0, __deltemplate_s1060_4a8d8c89);


/**
 * @param {{
 *  label: (!goog.soy.data.SanitizedContent|string),
 *  _handleItemClick: (*|null|undefined),
 *  _handleItemKeyDown: (*|null|undefined),
 *  active: (boolean|null|undefined),
 *  checked: (boolean|null|undefined),
 *  disabled: (boolean|null|undefined),
 *  href: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  icon: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  icons: (?),
 *  inputName: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  inputValue: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  items: (!Array<?>|null|undefined),
 *  itemsIconAlignment: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  maxItems: (null|number|undefined),
 *  separator: (boolean|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  target: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  title: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  type: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes}
 */
function __deltemplate_s1099_e71956db(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  /** @type {!goog.soy.data.SanitizedContent|string} */
  var label = soy.asserts.assertType(goog.isString(opt_data.label) || opt_data.label instanceof goog.soy.data.SanitizedContent, 'label', opt_data.label, '!goog.soy.data.SanitizedContent|string');
  /** @type {*|null|undefined} */
  var _handleItemClick = opt_data._handleItemClick;
  /** @type {*|null|undefined} */
  var _handleItemKeyDown = opt_data._handleItemKeyDown;
  /** @type {boolean|null|undefined} */
  var active = soy.asserts.assertType(opt_data.active == null || (goog.isBoolean(opt_data.active) || opt_data.active === 1 || opt_data.active === 0), 'active', opt_data.active, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var checked = soy.asserts.assertType(opt_data.checked == null || (goog.isBoolean(opt_data.checked) || opt_data.checked === 1 || opt_data.checked === 0), 'checked', opt_data.checked, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var disabled = soy.asserts.assertType(opt_data.disabled == null || (goog.isBoolean(opt_data.disabled) || opt_data.disabled === 1 || opt_data.disabled === 0), 'disabled', opt_data.disabled, 'boolean|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var href = soy.asserts.assertType(opt_data.href == null || (goog.isString(opt_data.href) || opt_data.href instanceof goog.soy.data.SanitizedContent), 'href', opt_data.href, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var icon = soy.asserts.assertType(opt_data.icon == null || (goog.isString(opt_data.icon) || opt_data.icon instanceof goog.soy.data.SanitizedContent), 'icon', opt_data.icon, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {?} */
  var icons = opt_data.icons;
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var inputName = soy.asserts.assertType(opt_data.inputName == null || (goog.isString(opt_data.inputName) || opt_data.inputName instanceof goog.soy.data.SanitizedContent), 'inputName', opt_data.inputName, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var inputValue = soy.asserts.assertType(opt_data.inputValue == null || (goog.isString(opt_data.inputValue) || opt_data.inputValue instanceof goog.soy.data.SanitizedContent), 'inputValue', opt_data.inputValue, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!Array<?>|null|undefined} */
  var items = soy.asserts.assertType(opt_data.items == null || goog.isArray(opt_data.items), 'items', opt_data.items, '!Array<?>|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var itemsIconAlignment = soy.asserts.assertType(opt_data.itemsIconAlignment == null || (goog.isString(opt_data.itemsIconAlignment) || opt_data.itemsIconAlignment instanceof goog.soy.data.SanitizedContent), 'itemsIconAlignment', opt_data.itemsIconAlignment, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {null|number|undefined} */
  var maxItems = soy.asserts.assertType(opt_data.maxItems == null || goog.isNumber(opt_data.maxItems), 'maxItems', opt_data.maxItems, 'null|number|undefined');
  /** @type {boolean|null|undefined} */
  var separator = soy.asserts.assertType(opt_data.separator == null || (goog.isBoolean(opt_data.separator) || opt_data.separator === 1 || opt_data.separator === 0), 'separator', opt_data.separator, 'boolean|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var spritemap = soy.asserts.assertType(opt_data.spritemap == null || (goog.isString(opt_data.spritemap) || opt_data.spritemap instanceof goog.soy.data.SanitizedContent), 'spritemap', opt_data.spritemap, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var target = soy.asserts.assertType(opt_data.target == null || (goog.isString(opt_data.target) || opt_data.target instanceof goog.soy.data.SanitizedContent), 'target', opt_data.target, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var title = soy.asserts.assertType(opt_data.title == null || (goog.isString(opt_data.title) || opt_data.title instanceof goog.soy.data.SanitizedContent), 'title', opt_data.title, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var type = soy.asserts.assertType(opt_data.type == null || (goog.isString(opt_data.type) || opt_data.type instanceof goog.soy.data.SanitizedContent), 'type', opt_data.type, '!goog.soy.data.SanitizedContent|null|string|undefined');
  var radio__soy1120 = function() {
    $templateAlias7({checked: checked, disabled: disabled, inline: true, label: label, name: inputName, value: inputValue}, null, opt_ijData);
  };
  var itemAttributes__soy1131 = function() {
    incrementalDom.attr('class', 'dropdown-item' + (active || checked ? ' active' : ''));
    if (!disabled) {
      incrementalDom.attr('data-onchange', _handleItemClick);
    }
    incrementalDom.attr('data-onkeydown', _handleItemKeyDown);
    incrementalDom.attr('tabindex', '-1');
  };
  incrementalDom.elementOpenStart('li');
      itemAttributes__soy1131();
  incrementalDom.elementOpenEnd();
    radio__soy1120();
  incrementalDom.elementClose('li');
}
exports.__deltemplate_s1099_e71956db = __deltemplate_s1099_e71956db;
/**
 * @typedef {{
 *  label: (!goog.soy.data.SanitizedContent|string),
 *  _handleItemClick: (*|null|undefined),
 *  _handleItemKeyDown: (*|null|undefined),
 *  active: (boolean|null|undefined),
 *  checked: (boolean|null|undefined),
 *  disabled: (boolean|null|undefined),
 *  href: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  icon: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  icons: (?),
 *  inputName: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  inputValue: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  items: (!Array<?>|null|undefined),
 *  itemsIconAlignment: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  maxItems: (null|number|undefined),
 *  separator: (boolean|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  target: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  title: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  type: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }}
 */
__deltemplate_s1099_e71956db.Params;
if (goog.DEBUG) {
  __deltemplate_s1099_e71956db.soyTemplateName = 'ClayDropdownItem.__deltemplate_s1099_e71956db';
}
soy.$$registerDelegateFn(soy.$$getDelTemplateId('ClayDropdownItem.Item.idom'), 'radio', 0, __deltemplate_s1099_e71956db);


/**
 * @param {{
 *  label: (!goog.soy.data.SanitizedContent|string),
 *  _handleItemClick: (*|null|undefined),
 *  _handleItemKeyDown: (*|null|undefined),
 *  active: (boolean|null|undefined),
 *  checked: (boolean|null|undefined),
 *  disabled: (boolean|null|undefined),
 *  href: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  icon: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  icons: (?),
 *  inputName: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  inputValue: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  items: (!Array<?>|null|undefined),
 *  itemsIconAlignment: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  maxItems: (null|number|undefined),
 *  separator: (boolean|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  target: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  title: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  type: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes}
 */
function __deltemplate_s1150_efbc8015(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  /** @type {!goog.soy.data.SanitizedContent|string} */
  var label = soy.asserts.assertType(goog.isString(opt_data.label) || opt_data.label instanceof goog.soy.data.SanitizedContent, 'label', opt_data.label, '!goog.soy.data.SanitizedContent|string');
  /** @type {*|null|undefined} */
  var _handleItemClick = opt_data._handleItemClick;
  /** @type {*|null|undefined} */
  var _handleItemKeyDown = opt_data._handleItemKeyDown;
  /** @type {boolean|null|undefined} */
  var active = soy.asserts.assertType(opt_data.active == null || (goog.isBoolean(opt_data.active) || opt_data.active === 1 || opt_data.active === 0), 'active', opt_data.active, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var checked = soy.asserts.assertType(opt_data.checked == null || (goog.isBoolean(opt_data.checked) || opt_data.checked === 1 || opt_data.checked === 0), 'checked', opt_data.checked, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var disabled = soy.asserts.assertType(opt_data.disabled == null || (goog.isBoolean(opt_data.disabled) || opt_data.disabled === 1 || opt_data.disabled === 0), 'disabled', opt_data.disabled, 'boolean|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var href = soy.asserts.assertType(opt_data.href == null || (goog.isString(opt_data.href) || opt_data.href instanceof goog.soy.data.SanitizedContent), 'href', opt_data.href, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var icon = soy.asserts.assertType(opt_data.icon == null || (goog.isString(opt_data.icon) || opt_data.icon instanceof goog.soy.data.SanitizedContent), 'icon', opt_data.icon, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {?} */
  var icons = opt_data.icons;
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var inputName = soy.asserts.assertType(opt_data.inputName == null || (goog.isString(opt_data.inputName) || opt_data.inputName instanceof goog.soy.data.SanitizedContent), 'inputName', opt_data.inputName, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var inputValue = soy.asserts.assertType(opt_data.inputValue == null || (goog.isString(opt_data.inputValue) || opt_data.inputValue instanceof goog.soy.data.SanitizedContent), 'inputValue', opt_data.inputValue, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!Array<?>|null|undefined} */
  var items = soy.asserts.assertType(opt_data.items == null || goog.isArray(opt_data.items), 'items', opt_data.items, '!Array<?>|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var itemsIconAlignment = soy.asserts.assertType(opt_data.itemsIconAlignment == null || (goog.isString(opt_data.itemsIconAlignment) || opt_data.itemsIconAlignment instanceof goog.soy.data.SanitizedContent), 'itemsIconAlignment', opt_data.itemsIconAlignment, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {null|number|undefined} */
  var maxItems = soy.asserts.assertType(opt_data.maxItems == null || goog.isNumber(opt_data.maxItems), 'maxItems', opt_data.maxItems, 'null|number|undefined');
  /** @type {boolean|null|undefined} */
  var separator = soy.asserts.assertType(opt_data.separator == null || (goog.isBoolean(opt_data.separator) || opt_data.separator === 1 || opt_data.separator === 0), 'separator', opt_data.separator, 'boolean|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var spritemap = soy.asserts.assertType(opt_data.spritemap == null || (goog.isString(opt_data.spritemap) || opt_data.spritemap instanceof goog.soy.data.SanitizedContent), 'spritemap', opt_data.spritemap, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var target = soy.asserts.assertType(opt_data.target == null || (goog.isString(opt_data.target) || opt_data.target instanceof goog.soy.data.SanitizedContent), 'target', opt_data.target, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var title = soy.asserts.assertType(opt_data.title == null || (goog.isString(opt_data.title) || opt_data.title instanceof goog.soy.data.SanitizedContent), 'title', opt_data.title, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var type = soy.asserts.assertType(opt_data.type == null || (goog.isString(opt_data.type) || opt_data.type instanceof goog.soy.data.SanitizedContent), 'type', opt_data.type, '!goog.soy.data.SanitizedContent|null|string|undefined');
  if (label && label != '') {
    incrementalDom.elementOpenStart('li');
        incrementalDom.attr('class', 'dropdown-subheader');
        incrementalDom.attr('role', 'presentation');
    incrementalDom.elementOpenEnd();
      soyIdom.print(label);
    incrementalDom.elementClose('li');
  }
  incrementalDom.elementOpenStart('li');
      incrementalDom.attr('aria-label', label);
      incrementalDom.attr('role', 'radiogroup');
  incrementalDom.elementOpenEnd();
    if (items) {
      incrementalDom.elementOpenStart('ul');
          incrementalDom.attr('class', 'list-unstyled');
      incrementalDom.elementOpenEnd();
        $templateAlias6({_handleItemClick: _handleItemClick, _handleItemKeyDown: _handleItemKeyDown, contentRenderer: 'radio', items: items, itemsIconAlignment: itemsIconAlignment, maxItems: maxItems, spritemap: spritemap}, null, opt_ijData);
      incrementalDom.elementClose('ul');
    }
  incrementalDom.elementClose('li');
}
exports.__deltemplate_s1150_efbc8015 = __deltemplate_s1150_efbc8015;
/**
 * @typedef {{
 *  label: (!goog.soy.data.SanitizedContent|string),
 *  _handleItemClick: (*|null|undefined),
 *  _handleItemKeyDown: (*|null|undefined),
 *  active: (boolean|null|undefined),
 *  checked: (boolean|null|undefined),
 *  disabled: (boolean|null|undefined),
 *  href: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  icon: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  icons: (?),
 *  inputName: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  inputValue: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  items: (!Array<?>|null|undefined),
 *  itemsIconAlignment: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  maxItems: (null|number|undefined),
 *  separator: (boolean|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  target: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  title: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  type: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }}
 */
__deltemplate_s1150_efbc8015.Params;
if (goog.DEBUG) {
  __deltemplate_s1150_efbc8015.soyTemplateName = 'ClayDropdownItem.__deltemplate_s1150_efbc8015';
}
soy.$$registerDelegateFn(soy.$$getDelTemplateId('ClayDropdownItem.Item.idom'), 'radiogroup', 0, __deltemplate_s1150_efbc8015);


/**
 * @param {{
 *  label: (!goog.soy.data.SanitizedContent|string),
 *  _handleItemClick: (*|null|undefined),
 *  _handleItemKeyDown: (*|null|undefined),
 *  active: (boolean|null|undefined),
 *  checked: (boolean|null|undefined),
 *  disabled: (boolean|null|undefined),
 *  href: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  icon: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  icons: (?),
 *  inputName: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  inputValue: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  items: (!Array<?>|null|undefined),
 *  itemsIconAlignment: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  maxItems: (null|number|undefined),
 *  separator: (boolean|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  target: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  title: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  type: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes}
 */
function __deltemplate_s1192_03a3ad8c(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  /** @type {!goog.soy.data.SanitizedContent|string} */
  var label = soy.asserts.assertType(goog.isString(opt_data.label) || opt_data.label instanceof goog.soy.data.SanitizedContent, 'label', opt_data.label, '!goog.soy.data.SanitizedContent|string');
  /** @type {*|null|undefined} */
  var _handleItemClick = opt_data._handleItemClick;
  /** @type {*|null|undefined} */
  var _handleItemKeyDown = opt_data._handleItemKeyDown;
  /** @type {boolean|null|undefined} */
  var active = soy.asserts.assertType(opt_data.active == null || (goog.isBoolean(opt_data.active) || opt_data.active === 1 || opt_data.active === 0), 'active', opt_data.active, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var checked = soy.asserts.assertType(opt_data.checked == null || (goog.isBoolean(opt_data.checked) || opt_data.checked === 1 || opt_data.checked === 0), 'checked', opt_data.checked, 'boolean|null|undefined');
  /** @type {boolean|null|undefined} */
  var disabled = soy.asserts.assertType(opt_data.disabled == null || (goog.isBoolean(opt_data.disabled) || opt_data.disabled === 1 || opt_data.disabled === 0), 'disabled', opt_data.disabled, 'boolean|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var href = soy.asserts.assertType(opt_data.href == null || (goog.isString(opt_data.href) || opt_data.href instanceof goog.soy.data.SanitizedContent), 'href', opt_data.href, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var icon = soy.asserts.assertType(opt_data.icon == null || (goog.isString(opt_data.icon) || opt_data.icon instanceof goog.soy.data.SanitizedContent), 'icon', opt_data.icon, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {?} */
  var icons = opt_data.icons;
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var inputName = soy.asserts.assertType(opt_data.inputName == null || (goog.isString(opt_data.inputName) || opt_data.inputName instanceof goog.soy.data.SanitizedContent), 'inputName', opt_data.inputName, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var inputValue = soy.asserts.assertType(opt_data.inputValue == null || (goog.isString(opt_data.inputValue) || opt_data.inputValue instanceof goog.soy.data.SanitizedContent), 'inputValue', opt_data.inputValue, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!Array<?>|null|undefined} */
  var items = soy.asserts.assertType(opt_data.items == null || goog.isArray(opt_data.items), 'items', opt_data.items, '!Array<?>|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var itemsIconAlignment = soy.asserts.assertType(opt_data.itemsIconAlignment == null || (goog.isString(opt_data.itemsIconAlignment) || opt_data.itemsIconAlignment instanceof goog.soy.data.SanitizedContent), 'itemsIconAlignment', opt_data.itemsIconAlignment, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {null|number|undefined} */
  var maxItems = soy.asserts.assertType(opt_data.maxItems == null || goog.isNumber(opt_data.maxItems), 'maxItems', opt_data.maxItems, 'null|number|undefined');
  /** @type {boolean|null|undefined} */
  var separator = soy.asserts.assertType(opt_data.separator == null || (goog.isBoolean(opt_data.separator) || opt_data.separator === 1 || opt_data.separator === 0), 'separator', opt_data.separator, 'boolean|null|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var spritemap = soy.asserts.assertType(opt_data.spritemap == null || (goog.isString(opt_data.spritemap) || opt_data.spritemap instanceof goog.soy.data.SanitizedContent), 'spritemap', opt_data.spritemap, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var target = soy.asserts.assertType(opt_data.target == null || (goog.isString(opt_data.target) || opt_data.target instanceof goog.soy.data.SanitizedContent), 'target', opt_data.target, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var title = soy.asserts.assertType(opt_data.title == null || (goog.isString(opt_data.title) || opt_data.title instanceof goog.soy.data.SanitizedContent), 'title', opt_data.title, '!goog.soy.data.SanitizedContent|null|string|undefined');
  /** @type {!goog.soy.data.SanitizedContent|null|string|undefined} */
  var type = soy.asserts.assertType(opt_data.type == null || (goog.isString(opt_data.type) || opt_data.type instanceof goog.soy.data.SanitizedContent), 'type', opt_data.type, '!goog.soy.data.SanitizedContent|null|string|undefined');
  incrementalDom.elementOpenStart('li');
      incrementalDom.attr('aria-hidden', 'true');
      incrementalDom.attr('class', 'dropdown-divider');
      incrementalDom.attr('role', 'presentation');
  incrementalDom.elementOpenEnd();
  incrementalDom.elementClose('li');
}
exports.__deltemplate_s1192_03a3ad8c = __deltemplate_s1192_03a3ad8c;
/**
 * @typedef {{
 *  label: (!goog.soy.data.SanitizedContent|string),
 *  _handleItemClick: (*|null|undefined),
 *  _handleItemKeyDown: (*|null|undefined),
 *  active: (boolean|null|undefined),
 *  checked: (boolean|null|undefined),
 *  disabled: (boolean|null|undefined),
 *  href: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  icon: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  icons: (?),
 *  inputName: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  inputValue: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  items: (!Array<?>|null|undefined),
 *  itemsIconAlignment: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  maxItems: (null|number|undefined),
 *  separator: (boolean|null|undefined),
 *  spritemap: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  target: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  title: (!goog.soy.data.SanitizedContent|null|string|undefined),
 *  type: (!goog.soy.data.SanitizedContent|null|string|undefined)
 * }}
 */
__deltemplate_s1192_03a3ad8c.Params;
if (goog.DEBUG) {
  __deltemplate_s1192_03a3ad8c.soyTemplateName = 'ClayDropdownItem.__deltemplate_s1192_03a3ad8c';
}
soy.$$registerDelegateFn(soy.$$getDelTemplateId('ClayDropdownItem.Item.idom'), 'separator', 0, __deltemplate_s1192_03a3ad8c);

exports.render.params = ["_handleItemClick","_handleItemKeyDown","active","checked","contentRenderer","disabled","href","icon","icons","inputName","inputValue","items","itemsIconAlignment","label","maxItems","separator","spritemap","target","title","type"];
exports.render.types = {"_handleItemClick":"any","_handleItemKeyDown":"any","active":"bool","checked":"bool","contentRenderer":"string","disabled":"bool","href":"string","icon":"string","icons":"?","inputName":"string","inputValue":"string","items":"list<?>","itemsIconAlignment":"string","label":"string","maxItems":"int","separator":"bool","spritemap":"string","target":"string","title":"string","type":"string"};
templates = exports;
return exports;

});

class ClayDropdownItem extends Component {}
Soy.register(ClayDropdownItem, templates);
export { ClayDropdownItem, templates };
export default templates;
/* jshint ignore:end */
